// extracted by mini-css-extract-plugin
export default {"content":"components_content__iohSG","steps":"components_steps__x55pY","firstStep":"components_firstStep__01gvK","txt":"components_txt__LbePn","finish":"components_finish__b8L-i"};